import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../components/TableContent';
import { DirectTreasuryAssetsQueryItem } from '../../../../../store/customerAssetDetail/types';
import { QuoteButton } from '../../QuoteButton';
import { IDynamicProductSearchItem } from '../_dynamic';

import { tableHead } from './constants';

const ProductSearchItem = ({
  item,
  product,
  quoteButtonInfoGetter,
}: IDynamicProductSearchItem<DirectTreasuryAssetsQueryItem>) => {
  const hasQuoteButton = !!quoteButtonInfoGetter;

  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} py={Spacing['stack.xxs']} px={Spacing['inline.xxxs']}>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        bottom={0}
        w={'4px'}
        backgroundColor={Color[product.colorNormalized]}
        borderTopLeftRadius={'full'}
        borderBottomLeftRadius={'full'}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{item.productNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.productTypeNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.availableQuantityNormalized.toString()}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.blockedQuantityNormalized.toString()}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>{item.totalQuantityNormalized.toString()}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{item.expirationDateNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{item.valueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      {hasQuoteButton && (
        <TableContentItemColumn flex={getFlex(7)}>
          <QuoteButton {...quoteButtonInfoGetter(item)} />
        </TableContentItemColumn>
      )}
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
